import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "gfu-project-description",
  "data-qa": "store-project-home:Contents"
}
const _hoisted_2 = { class: "gfu-layout__main gfu-layout__main--extranarrow _pt-6 js-main-content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_project_navigation = _resolveComponent("project-navigation")
  const _component_table_of_contents = _resolveComponent("table-of-contents")
  const _component_mini_wizard_manager = _resolveComponent("mini-wizard-manager")
  const _component_store_product_categories_list = _resolveComponent("store-product-categories-list")
  const _component_legal_entity_information = _resolveComponent("legal-entity-information")
  const _component_project_recommendations = _resolveComponent("project-recommendations")

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { id: "navigation" }, null, -1 /* CACHED */)),
    _createVNode(_component_project_navigation, {
      items: $props.navigation.items
    }, null, 8 /* PROPS */, ["items"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_table_of_contents),
      _createVNode(_component_mini_wizard_manager, { "is-mini-wizard-enabled": true }),
      _createElementVNode("main", _hoisted_2, [
        _createVNode(_component_store_product_categories_list, { "product-categories": $props.productCategories }, null, 8 /* PROPS */, ["product-categories"]),
        _createVNode(_component_legal_entity_information, {
          fill: true,
          emphasized: false
        }),
        _createVNode(_component_project_recommendations, {
          class: "_mt-4",
          quantity: 12,
          "exclude-project-ids": [$options.projectId],
          source: "project-home"
        }, null, 8 /* PROPS */, ["exclude-project-ids"])
      ])
    ])
  ]))
}